/**
 * PERSON SOURCE API — Wrapper REST per la lookup PersonSource (read-only).
 *
 * Contratto backend (rest-openapi.yaml):
 *   - GET /people/{groupId}/sources   pagination server-side -> Page<PersonSource>
 *     Query params: page (1-based, default 1), pageSize (default 20),
 *                   sort (es. "name:asc"), search (substring case-insensitive).
 *
 * NB: il backend NON espone CRUD su PersonSource — la creazione avviene
 * implicitamente server-side via find-or-create quando PersonInput
 * arriva con `personSource` valorizzato (vedi PersonSourceLocalService.
 * fetchPersonSource + addPersonSource). Quindi qui esiste SOLO `getAll`.
 */

import type { Page, ServerListParams } from '@crm/shared';
import { httpClient } from '../../api/httpClient';
import type { PersonSource } from './personSourceTypes';

const PEOPLE = '/people';

export const personSourceApi = {
  getAll: (groupId: number, params?: ServerListParams): Promise<Page<PersonSource>> =>
    httpClient
      .get<Page<PersonSource>>(`${PEOPLE}/${groupId}/sources`, {
        params: params as Record<string, unknown> | undefined,
      })
      .then((r) => r.data),
};
